import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeQuoteBiddingDetails } from './normalize';

export const fetchQuoteBiddingDetails = createProvider(api.fetchQuoteBiddingDetails)
  .andThen((res) => normalizeQuoteBiddingDetails(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
